import React from 'react';
import { Sparkles } from 'lucide-react';

export default function GuidedPromptBanner() {
  return (
    <div className="relative overflow-hidden rounded-xl teal-gradient px-6 py-5 text-white">
      <div className="absolute top-0 right-0 w-40 h-40 opacity-10 rounded-full bg-white -translate-y-1/2 translate-x-1/2" />
      <div className="relative flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5 w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
          <Sparkles size={16} className="text-white" />
        </div>
        <div>
          <p className="text-xs font-600 uppercase tracking-widest text-white/70 mb-1">
            Today&apos;s Reflection Prompt
          </p>
          <p className="text-base font-500 text-white leading-relaxed">
            Think of one small thing that went well yesterday — no matter how minor. 
            What was it, and how did it make you feel?
          </p>
          <p className="text-xs text-white/60 mt-2">
            You can use this as a starting point for your diary entry today.
          </p>
        </div>
      </div>
    </div>
  );
}